/** Форматирование дат и сумм. */

const MONTHS = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

const WEEKDAYS = ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'];

function sameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/** «Сегодня, 19:00» · «Завтра, 10:30» · «24 августа, 19:00» */
export function formatEventDate(iso: string): string {
  const date = new Date(iso);
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);

  const time = date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
  });

  if (sameDay(date, now)) return `Сегодня, ${time}`;
  if (sameDay(date, tomorrow)) return `Завтра, ${time}`;

  const day = `${date.getDate()} ${MONTHS[date.getMonth()]}`;
  const withYear =
    date.getFullYear() === now.getFullYear() ? day : `${day} ${date.getFullYear()}`;
  return `${withYear}, ${time}`;
}

export function formatWeekday(iso: string): string {
  return WEEKDAYS[new Date(iso).getDay()];
}

/** IDR не имеет дробной части, поэтому только разряды: 500 000 IDR */
export function formatIdr(amount: number): string {
  if (amount === 0) return 'Бесплатно';
  return `${amount.toLocaleString('ru-RU')} IDR`;
}

/** «Осталось 4 места» с правильным окончанием. */
export function formatSpotsLeft(left: number): string {
  const mod10 = left % 10;
  const mod100 = left % 100;
  let word = 'мест';
  if (mod10 === 1 && mod100 !== 11) word = 'место';
  else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) word = 'места';
  return `Осталось ${left} ${word}`;
}

/** «14 участников» */
export function formatGoing(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  let word = 'участников';
  if (mod10 === 1 && mod100 !== 11) word = 'участник';
  else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) word = 'участника';
  return `${count} ${word}`;
}
